// ==========================================
// Onboarding Validations
// ==========================================

export const validatePlanCreationForm = (values) => {
  const errors = {};

  // Plan Name validation
  if (!values.planName?.trim()) {
    errors.planName = "Plan name is required";
  }

  // Duration validation
  if (!values.duration) {
    errors.duration = "Duration is required";
  }

  // Base Price validation
  if (!values.basePrice || Number(values.basePrice) < 0) {
    errors.basePrice = "Valid base price is required";
  }

  // Max Members validation
  if (!values.maxMembers || Number(values.maxMembers) <= 0) {
    errors.maxMembers = "Max members must be greater than 0";
  }

  // Max Gyms validation
  if (!values.maxGyms || Number(values.maxGyms) <= 0) {
    errors.maxGyms = "Max gyms must be greater than 0";
  }

  // Features validation
  if (values.selectedFeatures.length === 0) {
    errors.selectedFeatures = "At least one feature must be selected";
  }

  // Valid From validation
  if (!values.validFrom?.trim()) {
    errors.validFrom = "Valid from date is required";
  }

  // Valid To validation
  if (!values.validTo?.trim()) {
    errors.validTo = "Valid to date is required";
  }

  // Check if Valid To is after Valid From
  if (values.validFrom && values.validTo) {
    const fromDate = new Date(values.validFrom);
    const toDate = new Date(values.validTo);
    if (toDate <= fromDate) {
      errors.validTo = "Valid to date must be after valid from date";
    }
  }

  return errors;
};
